import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['inputCheckbox', 'counter']

  connect() {
    this.element[this.identifier] = this
  }

  isChecked() {
    return this.inputCheckboxTarget.checked
  }

  name() {
    return this.inputCheckboxTarget.getAttribute('name')
  }

  value() {
    return this.inputCheckboxTarget.value
  }
}
